import { __decorate, __metadata } from "tslib";
import { ApiProperty } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { OrderStatusEnum } from '../enum';
import { OrderExposeGroup } from '../interface';
import { ListOrderDateInfoDto } from './ListOrderDateInfoDto';
import { ListOrderDelayedInfoDto } from './ListOrderDelayedInfoDto';
import { ListOrderDiningOptionInfoDto } from './ListOrderDiningOptionInfoDto';
import { ListOrderPaymentInformationDto } from './ListOrderPaymentInformationDto';
import { ListOrderRecipientDto } from './ListOrderRecipientDto';
export class ListOrderDto {
}
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [OrderExposeGroup.LIST] }),
    __metadata("design:type", String)
], ListOrderDto.prototype, "merchantId", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [OrderExposeGroup.LIST] }),
    __metadata("design:type", String)
], ListOrderDto.prototype, "storeId", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [OrderExposeGroup.LIST] }),
    __metadata("design:type", String)
], ListOrderDto.prototype, "userId", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [OrderExposeGroup.LIST] }),
    __metadata("design:type", String)
], ListOrderDto.prototype, "uuid", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [OrderExposeGroup.LIST] }),
    __metadata("design:type", String)
], ListOrderDto.prototype, "orderNumber", void 0);
__decorate([
    ApiProperty({ type: () => String, enum: OrderStatusEnum }),
    Expose({ groups: [OrderExposeGroup.LIST] }),
    __metadata("design:type", String)
], ListOrderDto.prototype, "status", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [OrderExposeGroup.LIST] }),
    __metadata("design:type", Number)
], ListOrderDto.prototype, "total", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [OrderExposeGroup.LIST] }),
    __metadata("design:type", String)
], ListOrderDto.prototype, "tz", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [OrderExposeGroup.LIST] }),
    __metadata("design:type", Number)
], ListOrderDto.prototype, "total_quantity", void 0);
__decorate([
    Type(() => ListOrderRecipientDto),
    ApiProperty({ type: () => ListOrderRecipientDto }),
    Expose({ groups: [OrderExposeGroup.LIST] }),
    __metadata("design:type", ListOrderRecipientDto)
], ListOrderDto.prototype, "recipient", void 0);
__decorate([
    Type(() => ListOrderDelayedInfoDto),
    ApiProperty({ type: () => ListOrderDelayedInfoDto }),
    Expose({ groups: [OrderExposeGroup.LIST] }),
    __metadata("design:type", ListOrderDelayedInfoDto)
], ListOrderDto.prototype, "delayedInfo", void 0);
__decorate([
    Type(() => ListOrderDateInfoDto),
    ApiProperty({ type: () => ListOrderDateInfoDto }),
    Expose({ groups: [OrderExposeGroup.LIST] }),
    __metadata("design:type", ListOrderDateInfoDto)
], ListOrderDto.prototype, "dateInfo", void 0);
__decorate([
    Type(() => ListOrderDiningOptionInfoDto),
    ApiProperty({ type: () => ListOrderDiningOptionInfoDto }),
    Expose({ groups: [OrderExposeGroup.LIST] }),
    __metadata("design:type", ListOrderDiningOptionInfoDto)
], ListOrderDto.prototype, "diningOptionInfo", void 0);
__decorate([
    Type(() => ListOrderPaymentInformationDto),
    ApiProperty({ type: () => ListOrderPaymentInformationDto }),
    Expose({ groups: [OrderExposeGroup.LIST] }),
    __metadata("design:type", ListOrderPaymentInformationDto)
], ListOrderDto.prototype, "paymentInformation", void 0);
//# sourceMappingURL=ListOrderDto.js.map